import { create } from "zustand";
import { useShallow } from "zustand/react/shallow";

type SidebarState = {
  isOpen: boolean;
};

type SidebarActions = {
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
};

export const useSidebarStore = create<SidebarState & SidebarActions>(
  (set, get) => ({
    isOpen: !window.localStorage.getItem("sd-sidebar-collapsed"),
    folderId: null,
    openSidebar: () => {
      set({ isOpen: true });
      window.localStorage.removeItem("sd-sidebar-collapsed");
    },
    closeSidebar: () => {
      set({ isOpen: false });
      window.localStorage.setItem("sd-sidebar-collapsed", "true");
    },
    toggleSidebar: () => {
      const isOpen = !get().isOpen;
      set({ isOpen });
      if (isOpen) window.localStorage.removeItem("sd-sidebar-collapsed");
      else window.localStorage.setItem("sd-sidebar-collapsed", "true");
    },
  }),
);

export const useSidebarStoreShallow = <U>(
  selector: (store: SidebarState & SidebarActions) => U,
) => {
  return useSidebarStore(useShallow(selector));
};
